import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import { styled } from '@precis-digital/kurama/utils';
import Typography from '@precis-digital/kurama/Typography';
import ThemedImage from 'shared/components/Themed/Image';
import emptyStateImage from 'public/assets/images/banner_splash.png';
import { type ReactElement } from 'react';
import { useTranslation } from 'shared/translations';
const CopilotDrawerEmptyState = () => {
  const $ = _c(34);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "copilot.emptyState"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("imageAlt");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <StyledImageContainer><StyledImageBanner src={emptyStateImage} alt={t1} /></StyledImageContainer>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Typography variant="h3">{t3}</Typography>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("description");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("feature1");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <li>{t6}</li>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("feature2");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <li>{t8}</li>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("feature3");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10) {
    t11 = <li>{t10}</li>;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t7 || $[25] !== t9) {
    t12 = <ul>{t7}{t9}{t11}</ul>;
    $[23] = t11;
    $[24] = t7;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t5) {
    t13 = <StyledTypographyWithList>{t5}{t12}</StyledTypographyWithList>;
    $[27] = t12;
    $[28] = t5;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13 || $[31] !== t2 || $[32] !== t4) {
    t14 = <Grid display="flex" flexDirection="column" gap="16px">{t2}{t4}{t13}</Grid>;
    $[30] = t13;
    $[31] = t2;
    $[32] = t4;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
const StyledImageContainer = styled(Grid)(({
  theme
}) => ({
  height: '159px',
  width: '100%',
  overflow: 'hidden',
  background: `linear-gradient(to left, ${theme.tokens.background.semantic.info.tonal.superSoft.default} 0%, ${theme.tokens.background.semantic.warning.tonal.superSoft.default} 66%)`,
  borderRadius: theme.borderRadius.xLarge
}));
const StyledImageBanner = styled(ThemedImage)(() => ({
  height: '100%',
  width: 'auto'
}));
const StyledTypographyWithList = styled('div')(({
  theme
}) => ({
  ...theme.typography.body2,
  ul: {
    listStyleType: 'disc',
    marginBlockStart: '4px',
    marginBlockEnd: '4px',
    paddingInlineStart: '20px'
  }
}));
export default CopilotDrawerEmptyState;